import { queryOptions } from "@tanstack/react-query";
import { merchantFlowKeys } from "../api/merchantFlowKeys";
import { merchantFlowService } from "../api/merchantFlowService";
import type { FlowDetail } from "../types";

/** How often an open flow on screen is re-read: the merchant's step and presence move live. */
export const FLOW_LIVE_REFETCH_MS = 5_000;

/**
 * `refetchInterval` for a flow shown live: every 5 s while it is open. A closed flow cannot move
 * or be on the page again, and a read that failed is not retried on a timer: both stop.
 */
export function liveFlowRefetch(query: {
  state: { status: string; data?: FlowDetail };
}): number | false {
  if (query.state.status === "error") return false;
  return (query.state.data?.status ?? "open") === "open" ? FLOW_LIVE_REFETCH_MS : false;
}

/** S6. The modal reads it and copy-link fetches through it, so both share one cache entry. */
export const flowDetailQuery = (borrowerId: number, flowId: number) =>
  queryOptions({
    queryKey: merchantFlowKeys.detail(flowId),
    queryFn: () => merchantFlowService.detail(borrowerId, flowId),
  });

/** The merchant's uploads in one flow. File links expire within minutes: refetch on open. */
export const flowDocumentsQuery = (borrowerId: number, flowId: number) =>
  queryOptions({
    queryKey: merchantFlowKeys.documents(flowId),
    queryFn: () => merchantFlowService.documents(borrowerId, flowId),
    staleTime: 0,
  });

/** S11. */
export const downloadLinksQuery = (borrowerId: number, flowId: number) =>
  queryOptions({
    queryKey: merchantFlowKeys.downloadLinks(flowId),
    queryFn: () => merchantFlowService.listDownloadLinks(borrowerId, flowId),
  });
